.informationBlockWrapper {
  background-color: white;
}

.account {
  align-items: center;
}

.accountIndicatorsWrapper {
  margin-top: 15px;
  flex: 1 1 auto;
}

.accountIndicator {
  display: flex;
  line-height: 1.7rem;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
}

.accountIndicatorsBlock {
  border: 1px solid #e6e6e6;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
}

.accountIndicatorsLine {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.accountIndicatorText {
  color: #757575;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 0.7rem;
}

.userInfo {
  display: block;
  margin-left: 20px;
  padding-top: 15px;
}

.jobTitle {
  color: #757575;
  font-weight: 500;
  padding: 2px 0;
}

.accountIndicatorsMain {
  background-color: white;
  margin: 10px;
  padding: 10px;
  border-radius: 20px;
  box-shadow: 0 0 22px 2px rgba(0, 0, 0, 0.1);
}

.separate {
  width: 20px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .accountIndicatorsLine {
    gap: 0;
  }

  .accountIndicatorsBlock:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: -1px;
  }

  .accountIndicatorsBlock:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }


  .separate {
    display: none;
  }
}

.accountIndicatorsLonelyBlock {
  border: 1px solid #e6e6e6;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
}
